import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import LandingNavbar from '../layout/LandingNavbar';
import { AuroraText } from '../common/AuroraText';
import './LoginPage.css';

export default function LoginPage({ onLogin, params, onNavigate }) {
  return (
    <div className="login-page hp">
      <LandingNavbar company={null} onNavigate={onNavigate} view="login" />

      <div className="login-body">
        {/* LEFT COLUMN - DESKTOP ONLY */}
        <div className="login-left-desktop">
          <div className="login-hero">
            <h1>Test before your users do.</h1>
            <p className="login-subtitle">
              Real testers. Real phones. Real feedback from across India.
            </p>

            <ul className="login-trust-signals">
              <li>100+ testers across India</li>
              <li>Screen recordings + device telemetry</li>
              <li>AI-generated bug reports</li>
            </ul>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="login-right">
          <div className="login-form-box">
            <div className="login-mobile-header">
              <AuroraText colors={["#FF6B2B", "#FFD700", "#F97316", "#FF9153"]}>
                <span className="login-m-title">Explore BharatQA</span>
              </AuroraText>
              <p className="login-m-subtitle">Bharat's first real-device testing network.</p>
            </div>

            {params?.plan && params?.price && (
              <div className="login-plan-selected">
                Plan: <strong>{params.plan}</strong> — {params.price}
              </div>
            )}
            
            <div className="login-google-container">
              <span className="login-form-label">Continue with Google</span>
              <div className="login-google-wrap">
                <GoogleLogin
                  onSuccess={onLogin}
                  onError={() => alert('Login failed. Please try again.')}
                  theme="outline"
                  size="large"
                  text="signin_with"
                  shape="rectangular"
                  width="300"
                />
              </div>
            </div>

            <p className="login-note">
              Trusted by developers building for Bharat.<br/>
              No credit card required.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}